export const BRAND = {
  name: "StoryFrame AI",
  short: "StoryFrame",
  tagline: "From first idea to production-ready film — one intelligent creative workspace.",
  promise: "One story. One source of truth. Every stage of production connected.",
  socialHandle: "@storyframeai",
};
